import { useEffect, useState } from 'react';
import Rename from '../static/img/Rename.svg';
import Copy from '../static/img/Copy.svg';
import TabsDelete from '../static/img/tabs-delete.svg';
import DownloadCommentBankIcon from '../static/img/Download.svg';
import Preview from '../static/img/preview.svg';
import Reopen from '../static/icons/re-open-task.svg';
import Open from '../static/icons/open-icon.svg';
import RubricOutComeIcon from '../static/img/rubric-outcome.svg';
import Edit from '../static/icons/edit_icon_purple_24.svg';
import EditGray from '../static/icons/edit_gray.svg';
import Delete from '../static/icons/delete-logo.svg';
import Duplicate from '../static/img/Copy.svg';
import ThreeDots from '../static/icons/three-dot.svg';
import ArrowUp from '../static/img/arrowup2.svg';
import SharePurple from '../static/icons/purple-share-icon.svg';

function resizeImage(url, width, height) {
  return new Promise((resolve) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = () => {
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL());
    };

    img.src = url;
  });
}

let resizedIcons = null;

export const useResizedImage = () => {
  const [icons, setIcons] = useState(null);

  useEffect(() => {
    const prepareImages = async () => {
      const resizedExport = await resizeImage(DownloadCommentBankIcon, 20, 20);
      const resizedDelete = await resizeImage(TabsDelete, 20, 20);
      const resizedPreview = await resizeImage(Preview, 20, 20);
      const resizedReopen = await resizeImage(Reopen, 20, 20);
      const resizedOpen = await resizeImage(Open, 20, 20);
      const resizedRubric = await resizeImage(RubricOutComeIcon, 20, 20);
      const resizedEdit = await resizeImage(Edit, 20, 20);
      const resizedEditGray = await resizeImage(EditGray, 20, 20);
      const resizedDeleteNew = await resizeImage(Delete, 20, 20);
      const resizedDuplicate = await resizeImage(Duplicate, 20, 20);
      const resizedThreeDots = await resizeImage(ThreeDots, 20, 20);
      const resizedArrowUp = await resizeImage(ArrowUp, 20, 20);
      const resizedSharePurple = await resizeImage(SharePurple, 20, 20);

      resizedIcons = {
        export: resizedExport,
        delete: resizedDelete,
        preview: resizedPreview,
        reopen: resizedReopen,
        open: resizedOpen,
        rubric: resizedRubric,
        edit: resizedEdit,
        editGray: resizedEditGray,
        deleteNew: resizedDeleteNew,
        duplicate: resizedDuplicate,
        threeDots: resizedThreeDots,
        arrowUp: resizedArrowUp,
        sharePurple: resizedSharePurple
      };

      setIcons(resizedIcons);
    };

    if (!resizedIcons) {
      prepareImages();
    } else {
      setIcons(resizedIcons);
    }
  }, []);

  return icons;
};
